import request from "util/request";

import type { SsoProvider } from "./proof/screens/saml";

type AuthenticationTypesInput = { email: string };
type AuthenticationType = "sso" | "google_sign_in" | "password" | "email";
type AuthenticationTypes = Promise<{
  authenticationTypes: AuthenticationType[];
  ssoProvider: SsoProvider | undefined;
}>;
export function getAuthenticationTypes({ email }: AuthenticationTypesInput): AuthenticationTypes {
  return request("post", "authentication_types", {
    email,
  });
}
